export const ICON = require('./icon.png'); 
export const DOWNLOAD_BUTTON = require('./download_button.png'); 
export const HOME_BUTTON = require('./home_button.png'); 
export const Twitter_Pic=require('./words.png');
